import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { Header } from "./components/Header";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Passion } from "./components/Passion";
import { Projects } from "./components/Projects";
import { Skills } from "./components/Skills";
import { Home } from "./components/Home";
import { Footer } from "./components/Footer";
import { UpButton } from "./components/subcomponents/UpButton";
import { motion } from "framer-motion";
import { Contact } from "./components/Contact";

function App() {
	const [trigger, setTrigger] = useState(false);

	useEffect(() => {
		const onScroll = () => {
			setTrigger(window.scrollY > 100);
		};

		window.addEventListener("scroll", onScroll);
		onScroll();

		return () => {
			window.removeEventListener("scroll", onScroll);
		};
	}, []);

	return (
		<div className="App app-shell">
			<Router>
				<div className="app-main">
					<motion.div className="" layout>
					<Header />
					</motion.div>
					<motion.div
						className="vih mt-5 mt-md-0"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ duration: 1, delay: 1.5 }}
					>
						<Routes>
							<Route path="/" element={<Home />}></Route>
							<Route path="/skills" element={<Skills />}></Route>
							<Route path="/passion" element={<Passion />}></Route>
							<Route path="/projects" element={<Projects />}></Route>
							<Route path="/contact" element={<Contact />}></Route>
						</Routes>
					</motion.div>
				</div>
				<motion.div
					className=""
					layout
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 1, delay: 3 }}
				>
					<Footer />
				</motion.div>
				{trigger && (
					<UpButton
						as={motion.button}
						whileTap={{ scale: 0.75 }}
						className="d-none"
					/>
				)}
			</Router>
		</div>
	);
}

export default App;
